export const AUTH_COLORS = {
  PRIMARY_BLUE: '#1976d2',
  PRIMARY_BLUE_HOVER: '#1565c0',
  SIGNAL_PURPLE: '#9c27b0',
  SIGNAL_PURPLE_HOVER: '#7b1fa2',
  ACCENT_GREEN: '#4caf50',
  ACCENT_GREEN_HOVER: '#45a049',
  ERROR_RED: '#d32f2f',
  ERROR_RED_HOVER: '#c62828'
};

export const AUTH_BREAKPOINTS = {
  mobile: '(max-width:600px)',
  tablet: '(min-width:601px) and (max-width:960px)'
};

// Countries to exclude from Country of Residence dropdown
export const EXCLUDED_COUNTRIES = [
  'CF', // Central African Republic
  'CG', // Congo (Brazzaville)
  'CD', // Congo (Kinshasa)
  'CI', // Cote D'Ivoire
  'EC', // Ecuador
  'ER', // Eritrea
  'ET', // Ethiopia
  'GW', // Guinea-Bissau
  'HT', // Haiti
  'IR', // Iran
  'IQ', // Iraq
  'JP', // Japan
  'KP', // North Korea
  'KG', // Kyrgyzstan
  'LR', // Liberia
  'LY', // Libya
  'MM', // Myanmar
  'SL', // Sierra Leone
  'SO', // Somalia
  'SS', // South Sudan
  'SD', // Sudan
  'SY', // Syrian Arab Republic
  'US', // United States of America
  'EH', // Western Sahara
  'YE', // Yemen
  'ZW' // Zimbabwe
];

// All available countries from react-flags-select
const ALL_COUNTRIES = [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW'
];

// Generate allowed countries list by filtering out excluded ones
export const ALLOWED_COUNTRIES_FOR_RESIDENCE = ALL_COUNTRIES.filter(
  country => !EXCLUDED_COUNTRIES.includes(country)
);
